export const formattedToastMessage = (message: string = '', subtitle: string = '') => {
    return (
        <>
            <p className="text-start remotive-font m-0">
                <b>{message}</b> <br /> <span className="remotive-font-sm">{subtitle}</span>
            </p>
        </>
    )
}
